import { render } from "./StartLayout.vue?vue&type=template&id=076a4a80&scoped=true&ts=true"
import script from "./StartLayout.vue?vue&type=script&lang=ts"
export * from "./StartLayout.vue?vue&type=script&lang=ts"

import "./StartLayout.vue?vue&type=style&index=0&id=076a4a80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076a4a80"],['__file',"src/layout/StartLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "076a4a80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('076a4a80', __exports__)) {
    api.reload('076a4a80', __exports__)
  }
  
  module.hot.accept("./StartLayout.vue?vue&type=template&id=076a4a80&scoped=true&ts=true", () => {
    api.rerender('076a4a80', render)
  })

}


export default __exports__